/**
 * @generated SignedSource<<daa85f41a7bb0b10561da920ed38e04f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicCommentsFormTopicFragment$data = {
  readonly forum: {
    readonly owner: {
      readonly id: string;
    };
  };
  readonly id: string;
  readonly " $fragmentType": "TopicCommentsFormTopicFragment";
};
export type TopicCommentsFormTopicFragment$key = {
  readonly " $data"?: TopicCommentsFormTopicFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicCommentsFormTopicFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicCommentsFormTopicFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "452b88aa1f10fe6797ab1f0e06788e4e";

export default node;
